/**
 * @readonly
 * @enum {string}
 */
export const LinkDeviceType = Object.freeze({
    ASSEN: 'ASSEN',
    BADALONA: 'BADALONA',
    BREMEN: 'BREMEN',
    CAM50: 'CAM50',
    CAMPRO: 'CAMPRO',
    CAMLITE: 'CAMLITE',
    CRACOW: 'CRACOW',
    DRESDEN: 'DRESDEN',
    FIRENZE: 'FIRENZE',
    FORMENTERA: 'FORMENTERA',
    GLADSTONE: 'GLADSTONE',
    GOTHAM: 'GOTHAM',
    GREDING: 'GREDING',
    HOUSTON: 'HOUSTON',
    HUSUM: 'HUSUM',
    KIEL: 'KIEL',
    LANCASTER: 'LANCASTER',
    LINK310: 'LINK310',
    LOSANGELES: 'LOSANGELES',
    MATARO: 'MATARO',
    METROPOLIS: 'METROPOLIS',
    PRO5150: 'PRO5150',
    PRO5250: 'PRO5250',
    PRO5350: 'PRO5350',
    PROAPPPRO5: 'PROAPPPRO5',
    ROSETTA: 'ROSETTA',
    STARCITY: 'STARCITY',
    TORONTO: 'TORONTO',
    TPMSASSET: 'TPMSASSET',
    WARSAW: 'WARSAW'
})
